import { CounterpartyType } from 'openapi';

import { validateIban } from 'utils/helpers/invoiceHelpers';

export type CounterpartyApprovalBlocker = 'name' | 'expenseType' | 'iban';

export interface CounterpartyApprovalState {
  readonly isApproved: boolean;
  readonly hasName: boolean;
  readonly hasIban: boolean;
  readonly hasValidIban: boolean;
  readonly requiresExpenseType: boolean;
  readonly hasExpenseType: boolean;
  readonly blockers: CounterpartyApprovalBlocker[];
}

interface CounterpartyApprovalInput {
  readonly name: string;
  readonly type: CounterpartyType;
  readonly expenseTypeIds: number[];
  readonly ibans: { iban: string }[];
}

export const counterpartyRequiresExpenseType = (
  type: CounterpartyType
): boolean => type === CounterpartyType.SUPPLIER;

export const getCounterpartyApprovalState = ({
  name,
  type,
  expenseTypeIds,
  ibans
}: CounterpartyApprovalInput): CounterpartyApprovalState => {
  const requiresExpenseType = counterpartyRequiresExpenseType(type);
  const hasName = !!name.trim();
  const hasExpenseType = expenseTypeIds.length > 0;
  const populatedIbans = ibans.filter((iban) => !!iban.iban.trim());
  const hasIban = populatedIbans.length > 0;
  const hasValidIban = populatedIbans.some((iban) =>
    validateIban(iban.iban.trim())
  );

  const blockers: CounterpartyApprovalBlocker[] = [];

  if (!hasName) {
    blockers.push('name');
  }

  if (requiresExpenseType && !hasExpenseType) {
    blockers.push('expenseType');
  }

  if (!hasIban) {
    blockers.push('iban');
  }

  return {
    isApproved:
      hasName && hasValidIban && (!requiresExpenseType || hasExpenseType),
    hasName,
    hasIban,
    hasValidIban,
    requiresExpenseType,
    hasExpenseType,
    blockers
  };
};
